/* eslint-disable no-nested-ternary */
import React, { useState } from "react";

import { TaskInterface } from "services/api";
import formatarNumeroTelefone from "utils/regexPhone";
import { podeCorretorConcluirTarefa } from "utils/podeCorretorConcluirTarefa";
import { montarPdvEmpreendimento } from "utils/montarPdvEmpreendimento";
import { RootStateOrAny, useSelector } from "react-redux";
import { MdOutlineEmail } from "react-icons/md";
import * as Styles from "./styles";
import * as SVG from "../../../../../../../assets/iconsSVG";
import { AuthState } from "../../../../../../../store/ducks/auth/types";
import icons from "../../../../../../../constants/icons";

interface Props {
  statusTarefa: 1 | 2 | 3;
  data: TaskInterface;
  onOpenEditTask: (item: TaskInterface) => void;
  onOpenConcludeTask: (item: TaskInterface) => void;
}

const TaskCard: React.FC<Props> = (props) => {
  const { codigoCargo2013, codigoRegional365 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const isCorretor = codigoCargo2013 === "219.840.002";
  const isSul = codigoRegional365 === "2";
  const [mostrarTudo, setMostrarTudo] = useState(false);
  const limiteCaracteres = 250;
  const generateStatusColor = () => {
    switch (props?.data?.codigoStatusTarefa) {
      case 3:
        return { bgColor: "#4CAF50", textColor: "#ffffff", text: "Concluída" };
      case 1:
        return { bgColor: "#F43636", textColor: "#ffffff", text: "Atrasada" };
      case 2:
        return { bgColor: "#D5D5D5", textColor: "#333333", text: "Em Aberto" };
      default:
        return { bgColor: "#D5D5D5", textColor: "#333333", text: "Em Aberto" };
    }
  };

  return (
    <Styles.Container>
      {(props?.data?.tipoTarefa === "Agendamento de Visita" ||
        props?.data?.tipoTarefa === "Mobi") &&
      !isSul ? (
        <Styles.Row>
          <SVG.ProductPredio2 />
          <Styles.Title>
            {montarPdvEmpreendimento(
              props?.data?.nomePdv,
              props?.data?.empreendimento
            )}
          </Styles.Title>
        </Styles.Row>
      ) : null}

      {(props?.data?.tipoTarefa === "Agendamento de Visita" ||
        props?.data?.tipoTarefa === "Mobi") &&
      isSul ? (
        <Styles.Row>
          <SVG.ProductPredio2 />
          <Styles.Title>
            {montarPdvEmpreendimento(
              props?.data?.nomePdv,
              props?.data?.empreendimentoRegionalSul
            )}
          </Styles.Title>
        </Styles.Row>
      ) : null}

      <Styles.Row>
        <Styles.Column>
          <Styles.Title>{props?.data?.titulo || "--"}</Styles.Title>
          <Styles.RowGap>
            <Styles.Row>
              <SVG.UserTaskIcon />
              <Styles.Text>{props?.data?.nomeLead || "--"}</Styles.Text>
            </Styles.Row>
            <Styles.Row>
              <SVG.CalendarTaskIcon />
              <Styles.Text>
                {props?.data?.dataHoraProgramadaRealizacaoTarefa || "--"}
              </Styles.Text>
            </Styles.Row>
            <Styles.Row>
              <SVG.TaskIcon />
              <Styles.Text>{props?.data?.tipoTarefa || "--"}</Styles.Text>
            </Styles.Row>
            {props?.data?.tipoTarefa === "E-mail" ? (
              <Styles.Row>
                <MdOutlineEmail color="#303030" size={22} />
                <Styles.Text>{props?.data?.emailPrincipal || "--"}</Styles.Text>
              </Styles.Row>
            ) : (
              <Styles.Row>
                <SVG.WhatsappIcon />
                <Styles.Text>
                  {props?.data?.telefonePrincipal
                    ? formatarNumeroTelefone(props?.data?.telefonePrincipal)
                    : "--"}
                </Styles.Text>
              </Styles.Row>
            )}
          </Styles.RowGap>
        </Styles.Column>
        <Styles.RowAlign>
          <Styles.Badge color={generateStatusColor().bgColor}>
            <Styles.BadgeText color={generateStatusColor().textColor}>
              {generateStatusColor().text}
            </Styles.BadgeText>
          </Styles.Badge>
          {isCorretor ? (
            <Styles.RowAlign>
              <Styles.Button
                color="#EAEFFF"
                onClick={() => props.onOpenEditTask(props?.data)}
              >
                <SVG.EditTaskIcon />
              </Styles.Button>
              {podeCorretorConcluirTarefa(props?.data?.tipoTarefa, isSul) ? (
                <Styles.Button
                  color="rgba(76, 175, 80, 0.20)"
                  onClick={() => props.onOpenConcludeTask(props?.data)}
                >
                  <SVG.CheckTaskIcon />
                </Styles.Button>
              ) : null}
            </Styles.RowAlign>
          ) : null}
        </Styles.RowAlign>
      </Styles.Row>
      {props?.data?.descricao?.length > 0 ||
      props?.data?.observacao?.length > 0 ? (
        <Styles.MessageWrapper>
          <Styles.Row>
            <SVG.DescriptionIcon />
            <Styles.MessageTitle>
              {props.data.codigoStatusTarefa === 3
                ? "Observação sobre o resultado"
                : "Descrição"}
            </Styles.MessageTitle>
          </Styles.Row>
          <Styles.SpaceY space={4} />
          <Styles.TextDesc mostrarTudo={mostrarTudo}>
            {props.data.codigoStatusTarefa === 3
              ? props?.data?.observacao.length > limiteCaracteres &&
                !mostrarTudo
                ? `${props?.data?.observacao.slice(0, limiteCaracteres)}...`
                : props?.data?.observacao
              : props?.data?.descricao.length > limiteCaracteres && !mostrarTudo
              ? `${props?.data?.descricao.slice(0, limiteCaracteres)}...`
              : props?.data?.descricao}
          </Styles.TextDesc>
          {props.data.codigoStatusTarefa === 3 ? (
            props?.data?.observacao?.length > limiteCaracteres
          ) : props?.data?.descricao?.length > limiteCaracteres ? (
            <Styles.ButtonRightWrapper>
              <Styles.BotaoMostrarMais
                onClick={() => setMostrarTudo(!mostrarTudo)}
              >
                <p>{mostrarTudo ? "Mostrar menos" : "Mostrar mais"}</p>
              </Styles.BotaoMostrarMais>
            </Styles.ButtonRightWrapper>
          ) : null}
        </Styles.MessageWrapper>
      ) : null}
    </Styles.Container>
  );
};

export default TaskCard;
